import moment from 'moment/moment'
import { ALL, PaymentStatusFilter } from './constants'
import {
  approvedOrSigned,
  createStoreFilter,
  debitable,
  merchantPortalFilter,
  noCustomerInteractionRequiredOlderThan30Days,
  noSigningRequiredOlderThan30Days,
  notAnnulled,
  notCredited,
  notDebitedFilter,
  notFrozen,
  showOnlyOngoingOrDelayedPayments,
  signingRequired,
  signingType,
} from './ongoingPaymentsFilters'

export const debitDateHasPassed = debitDate =>
  moment(debitDate).isBefore(moment(), 'day')

export const buildCombinedFilters = searchFilters => {
  const { status = ALL, storeId = ALL } = searchFilters || {}

  const newFilters = [
    merchantPortalFilter,
    notDebitedFilter,
    notFrozen,
    notAnnulled,
    notCredited,
    noSigningRequiredOlderThan30Days,
    noCustomerInteractionRequiredOlderThan30Days,
    signingType,
    showOnlyOngoingOrDelayedPayments,
  ]

  if (status === PaymentStatusFilter.DEBITABLE) {
    newFilters.push(debitable)
    newFilters.push(approvedOrSigned)
  } else if (status === PaymentStatusFilter.UNSIGNED) {
    newFilters.push(signingRequired)
  }

  if (storeId !== ALL) {
    newFilters.push(createStoreFilter(storeId))
  }

  return newFilters
}
